import { useSearchParams } from 'react-router-dom';

import CustomFilterSelect from '../../shared/customFilterSelect';
import { normalizeAdminScope } from '../../utils/adminScope';
import './style.scss';

const PROCESS_OPTIONS = [
  { id: 'general', name: 'Todos los procesos' },
  { id: 'pf', name: 'Escuelas de Formación' },
  { id: 'diplom', name: 'Diplomados' },
  { id: 'ndn', name: 'Nada de Nervios' },
  { id: 'cs', name: 'Control Social' },
  { id: 'cop', name: 'Centro de Orientación Pedagógica (COP)' }
];

const GENERAL_PROCESS_SCOPES = ['general', 'pf', 'diplom', 'ndn'];

function AdminProcessScopeFilter({
  allowedScopes,
  className = '',
  onScopeChange,
  variant = 'custom'
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedScope = normalizeAdminScope(searchParams.get('scope')) || 'general';
  const visibleScopes = selectedScope === 'cop'
    ? ['cop']
    : selectedScope === 'cs'
      ? ['cs']
      : Array.isArray(allowedScopes) && allowedScopes.length > 0
        ? allowedScopes.filter(scope => GENERAL_PROCESS_SCOPES.includes(scope))
        : GENERAL_PROCESS_SCOPES;
  const options = PROCESS_OPTIONS.filter(option => visibleScopes.includes(option.id));
  const value = options.some(option => option.id === selectedScope)
    ? selectedScope
    : options[0]?.id || 'general';
  const selectedLabel = value === 'general'
    ? ''
    : options.find(option => option.id === value)?.name || '';

  function applyScope(nextScope) {
    if (typeof onScopeChange === 'function') {
      onScopeChange(nextScope);
    }
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set('scope', nextScope);
    nextSearchParams.delete('mediator');
    nextSearchParams.delete('expanded');
    setSearchParams(nextSearchParams, { replace: true });
  }

  if (variant === 'calendar') {
    return (
      <label className={`calendar-filters__field ${className}`.trim()}>
        <span>Proceso al que pertenece</span>
        <select value={value} onChange={event => applyScope(event.target.value)}>
          {options.map(option => (
            <option key={option.id} value={option.id}>{option.name}</option>
          ))}
        </select>
      </label>
    );
  }

  if (variant === 'workspace') {
    return (
      <label className={`admin-process-scope-filter--workspace ${className}`.trim()}>
        <span>Proceso al que pertenece</span>
        <select
          className='workspace-search__input'
          value={value}
          onChange={event => applyScope(event.target.value)}>
          {options.map(option => (
            <option key={option.id} value={option.id}>{option.name}</option>
          ))}
        </select>
      </label>
    );
  }

  return (
    <div className={`admin-process-scope-filter ${className}`.trim()}>
      <CustomFilterSelect
        optionsList={options}
        placeholder='Proceso al que pertenece'
        valueEdit={selectedLabel}
        addInfo={(_key, optionId) => applyScope(optionId)}
      />
    </div>
  );
}

export default AdminProcessScopeFilter;
